export const getSegmentFromImageStream = (trickPlayStream, seekTime) => {
  if (!trickPlayStream || seekTime === null) {
    return null
  }

  const { segmentDuration, imageDuration, layout, segments } = trickPlayStream

  const segmentIndex = Math.floor(seekTime / segmentDuration)
  const source = segments[segmentIndex]

  if (!source) {
    return null
  }

  const imageIndex = Math.floor((seekTime - segmentIndex * segmentDuration) / imageDuration)
  const row = Math.floor(imageIndex / layout.columns)
  const column = imageIndex % layout.columns

  return { source, row, column }
}
